import React, { useState, useEffect, useRef } from 'react'
import callApi from '../../helpers/callapi'
import { useDispatch } from 'react-redux'
import { Button, Card, Col, Row, Form } from 'react-bootstrap'
import * as Base64 from '../../helpers/base64'
import Cookies from 'js-cookie'
import config from '../../config'
import Swal from 'sweetalert2'
import Colors from '../../constants/Colors'
import { format, parse } from 'date-fns'
import axios from 'axios'
import ManageNoFee from './ManageNoFee'
import RoundCloseDetailForm from './RoundCloseDetailForm/RoundCloseDetailForm'
import EmptyLotteryImage from './EmptyLotteryImage'
import PrizesShareCampaignForm from './RoundCloseDetailForm/PrizesShareCampaignForm'

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ selectedConfig, setIsVisible, onClose, rounds, dates, dateBuy, me, fetchContents }) => {
  // const [user, setUser] = useState(selectedConfig);
  const [value, setValue] = useState('')
  const [time, setTime] = useState(['00', '00'])
  const dispatch = useDispatch()
  const [pathImg, setPathImg] = useState('')
  const [fileImg, setFileImg] = useState('')
  const [error, setError] = useState('')
  const inputRef = useRef(null)

  const uploadImg = async (event) => {
    if (event) {
      setPathImg(URL.createObjectURL(event.target.files[0]))
      setFileImg(event.target.files[0])
    }
  }

  const updateImg = async () => {
    if (fileImg) {
      // ยิง api เพื่อเก็บรูปภาพ
      dispatch({ type: 'loading_show' })
      const [base64] = await Promise.all([Base64.getBase64(fileImg)])
      const response = await fetch(`${config.urlHost}/uploadEmptyLotto`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify({ image: base64 }),
      }).then((response) => response.json())

      dispatch({ type: 'loading_hide' })
      if (response.url) {
        await axios.patch(
          `${config.apiAdminGateway}/api/v1/admin/configs/str/emptyImage`,
          { value: response.url },
          { headers: { authorization: `Bearer ${Cookies.get('accessToken')}` } },
        )
        Swal.fire({
          title: 'ทำการเปลี่ยนแปลงรูปภาพที่แสดงเมื่อลอตเตอรี่หมด สำเร็จ!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: Colors.SOFT_BLUE,
          confirmButtonText: 'ยืนยัน',
        }).then(async () => {
          fetchContents()
        })
      }
    }
  }

  // ยิง api เพื่อเก็บรูปภาพที่ใช้แสดงเมื่อปิดงวด
  const updateImageCloseRound = async () => {
    if (fileImg) {
      dispatch({ type: 'loading_show' })
      const [base64] = await Promise.all([Base64.getBase64(fileImg)])
      const response = await fetch(`${config.urlHost}/uploadRoundCloseImage`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
        body: JSON.stringify({ image: base64 }),
      }).then((response) => response.json())

      dispatch({ type: 'loading_hide' })
      if (response.url) {
        await axios.patch(
          `${config.apiAdminGateway}/api/v1/admin/configs/roundCloseDetail`,
          { imageUrl: response.url, roundCloseType: 'round-close' },
          { headers: { authorization: `Bearer ${Cookies.get('accessToken')}` } },
        )
        Swal.fire({
          title: 'ทำการเปลี่ยนแปลงรูปภาพที่แสดงเมื่อปิดงวด สำเร็จ!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: Colors.SOFT_BLUE,
          confirmButtonText: 'ยืนยัน',
        }).then(async () => {
          fetchContents()
        })
      }
    } else {
      dispatch({ type: 'loading_show' })
      try {
        await callApi({
          url: `/contents/round-close-image`,
          method: 'put',
          body: { value: '' },
        })

        Swal.fire({
          title: 'ทำการเปลี่ยนแปลงรูปภาพที่แสดงเมื่อปิดงวด สำเร็จ!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: Colors.SOFT_BLUE,
          confirmButtonText: 'ยืนยัน',
        }).then(async () => {
          fetchContents()
        })
      } catch (error) {
        Swal.fire({
          title: 'ทำการเปลี่ยนแปลงรูปภาพที่แสดงเมื่อปิดงวด ไม่สำเร็จ!',
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: Colors.DARK_RED,
          confirmButtonText: 'ยืนยัน',
        })
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    }
  }

  const alertBeforeHandle = (text, onFunc) => {
    Swal.fire({
      title: text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: Colors.SOFT_BLUE,
      cancelButtonColor: Colors.LIGHT_RED,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await onFunc()
      }
    })
  }

  useEffect(() => {
    setError('')
    setValue(selectedConfig.value)
    if (selectedConfig.name === 'emptyImage' || selectedConfig.name === 'roundCloseImage') {
      setPathImg(selectedConfig.value)
    }
    if (selectedConfig.name === 'nextRound')
      setTime(selectedConfig.value.split(' ').length === 2 ? selectedConfig.value.split(' ')[1].split(':') : time)
  }, [selectedConfig])

  const legacyUpdateConfig = async () => {
    if (selectedConfig.name === 'emptyImage') {
      alertBeforeHandle('ต้องการเปลี่ยนแปลงรูปภาพ', updateImg)
    } else if (selectedConfig.name === 'roundCloseImage') {
      alertBeforeHandle('ต้องการเปลี่ยนแปลงรูปภาพ', updateImageCloseRound)
    } else {
      if (selectedConfig.name === 'limitPreOrder' && (!value || isNaN(value))) {
        setError('กรุณากรอกข้อมูล')
        Swal.fire({
          title: 'กรุณากรอกข้อมูล',
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: Colors.DARK_RED,
          confirmButtonText: 'ยืนยัน',
        })
        return
      }

      if (inputType === 'limit-number') {
        if (!value || isNaN(value)) {
          setError('กรุณากรอกข้อมูล')
          Swal.fire({
            title: 'กรุณากรอกข้อมูล',
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: Colors.DARK_RED,
            confirmButtonText: 'ยืนยัน',
          })
          return
        }
        if (value < selectedConfig.min || value > selectedConfig.max) {
          setError('กรุณากรอกข้อมูลให้ไม่เกินค่าที่กำหนด')
          Swal.fire({
            title: 'กรุณากรอกข้อมูลให้ไม่เกินค่าที่กำหนด',
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: Colors.DARK_RED,
            confirmButtonText: 'ยืนยัน',
          })
          return
        }
      }

      alertBeforeHandle('ต้องการบันทึกการตั้งค่า', async () => {
        const configType = typeof value === 'boolean' ? 'bool' : typeof value === 'number' ? 'int' : 'str'
        try {
          dispatch({ type: 'loading_show' })
          await axios.patch(
            `${config.apiAdminGateway}/api/v1/admin/configs/${configType}/${selectedConfig.name}`,
            { value },
            { headers: { authorization: `Bearer ${Cookies.get('accessToken')}` } },
          )

          Swal.fire({
            title: 'บันทึกการตั้งค่าสำเร็จ!',
            icon: 'success',
            confirmButtonColor: Colors.SOFT_BLUE,
          }).then(() => {
            setIsVisible(false)
            onClose()
          })
        } catch (error) {
          console.error('Error while trying to fetch orders.', error)
        } finally {
          dispatch({ type: 'loading_hide' })
        }
      })
    }
  }

  const updateConfig = async (name = '', value = {}) => {
    if (name === 'roundCloseDetail') {
      setIsVisible(false)
      onClose()
      return
    }

    try {
      dispatch({ type: 'loading_show' })

      const res = await axios.post(
        `${config.apiAdminGateway}/api/v1/configs/${name}`,
        {
          ...value,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        },
      )
      const {
        status: { code, description },
      } = res.data
      if (code !== 0) {
        throw new Error(description)
      }
      setIsVisible(false)
      onClose()
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      console.error('Error while trying to fetch orders.', error)
      dispatch({ type: 'loading_hide' })
    }
  }

  let inputType = 'input'
  let showButton = true
  switch (selectedConfig.name) {
    case 'roundDate':
      inputType = 'select'
      break
    case 'emptyImage':
      inputType = 'empty-image'
      showButton = false
      break
    case 'roundCloseImage':
      inputType = 'round-close-image'
      break
    case 'feePrice':
    case 'lotteryPrice':
      inputType = 'input-number'
      break
    case 'cartExpire':
    case 'paymentExpire':
    case 'qrHoldItemExpire':
      inputType = 'limit-number'
      break
    case 'isRoundClosed':
    case 'showResult':
    case 'showBox':
    case 'isEnabledPoint':
    case 'isEnabledAffiliate':
    case 'isEnabledPreOrder':
    case 'isEnableQRcode':
    case 'isEnableSlip':
    case 'isEnableNokshop':
      inputType = 'boolean'
      break
    case 'allowCharity':
      inputType = 'boolean'
      break
    case 'nextRound':
      inputType = 'select-time'
      showButton = false
      break
    case 'roundCloseDetail':
      inputType = 'round-close-detail'
      showButton = false
      break
    case 'liveScan':
      inputType = 'text-area'
      break
    case 'liveType':
      inputType = 'select-live'
      break
    case 'noFee':
      inputType = 'noFee'
      break
    case 'limitPreOrder':
      inputType = 'input-number'
      break
    case 'prizesShareCampaign':
      inputType = 'prizes-share-campaign'
      showButton = false
      break
    default:
      break
  }

  return (
    <Card className="p-3">
      <h2> {selectedConfig.label} </h2>
      <Row>
        <Col className="p-3" md={12}>
          <ul className="list-group list-group-flush">
            <li className="list-group-item d-flex justify-content-between">
              <span className="mb-0" style={{ color: '#3d4465' }}>
                {selectedConfig.label}
              </span>
              <strong className="text"></strong>
            </li>
          </ul>
          <ul className="list-group list-group-flush">
            {/* <li className="list-group-item d-flex justify-content-between"> */}
            <span className="mb-0" style={{ color: '#3d4465' }}></span>
            <strong className="text">
              {inputType === 'select' && (
                <div className="form-group col-md-12">
                  <select
                    className="form-control"
                    placeholder="รอบวันที่"
                    value={value}
                    style={{ width: 250, marginBottom: 10 }}
                    onChange={(e) => {
                      setValue(e.target.value)
                    }}
                  >
                    {rounds &&
                      rounds.map((round, i) => {
                        return (
                          <option key={i} value={round.roundDate}>
                            {round.roundDate}
                          </option>
                        )
                      })}
                  </select>
                </div>
              )}
              {inputType === 'select-time' && <NextRoundConfig value={value} onSave={updateConfig} />}
              {inputType === 'round-close-detail' && <RoundCloseDetailForm value={value} onSave={updateConfig} />}
              {inputType === 'empty-image' && <EmptyLotteryImage />}
              {inputType === 'select-two-month' && (
                <div className="row">
                  {/* {console.log("value ===>>", value)} */}
                  <div className="form-group col-md-6">
                    <select
                      className="form-control"
                      placeholder={value && value !== true && value.split(' ')[0]}
                      defaultValue={value && value !== true && value.split(' ')[0]}
                      onChange={(e) => {
                        setValue(e.target.value)
                      }}
                    >
                      {dateBuy &&
                        dateBuy.map((day, i) => {
                          return (
                            <option key={i} value={day}>
                              {day}
                            </option>
                          )
                        })}
                    </select>
                  </div>
                </div>
              )}

              {inputType === 'input' && (
                <>
                  <input
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    placeholder="ค่า"
                    onChange={(e) => {
                      setError('')
                      setValue(e.target.value)
                    }}
                    value={value}
                  />
                  {error && <div className="invalid-feedback">{error}</div>}
                </>
              )}

              {inputType === 'input-number' && (
                <>
                  <input
                    type="number"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    min={0}
                    placeholder="ค่า"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => {
                      setError('')
                      setValue(parseInt(e.target.value))
                    }}
                    value={value}
                    isInvalid={!!error}
                  />
                  {error && <div className="invalid-feedback">{error}</div>}
                </>
              )}
              {inputType === 'limit-number' && (
                <div>
                  <span>
                    จํานวนเวลามากกว่า {selectedConfig.min} นาที ไม่เกิน {selectedConfig.max} นาที
                  </span>
                  <input
                    type="number"
                    className={`form-control ${error ? 'is-invalid' : ''}`}
                    min={selectedConfig.min}
                    max={selectedConfig.max}
                    placeholder="ค่า"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => {
                      setError('')
                      setValue(parseInt(e.target.value))
                    }}
                    value={value}
                    isInvalid={!!error}
                  />
                  {error && <div className="invalid-feedback">{error}</div>}
                </div>
              )}

              {inputType === 'text-area' && (
                <input
                  className="form-control"
                  rows={4}
                  placeholder="ค่า"
                  onChange={(e) => setValue(e.target.value)}
                  value={value}
                />
              )}

              {inputType === 'boolean' && (
                <select
                  className="form-control"
                  placeholder=""
                  value={value}
                  style={{ width: 250, marginBottom: 10 }}
                  onChange={(e) => setValue(JSON.parse(e.target.value))}
                >
                  <option key={'true'} value={true}>
                    {selectedConfig.name === 'isRoundClosed' && 'ปิดรอบ'}
                    {selectedConfig.name === 'showResult' && 'แสดง'}
                    {selectedConfig.name === 'showBox' && 'เปิด'}
                    {selectedConfig.name === 'isEnableQRcode' && 'เปิด'}
                    {selectedConfig.name === 'isEnabledPoint' && 'เปิด'}
                    {selectedConfig.name === 'isEnabledPreOrder' && 'เปิด'}
                    {selectedConfig.name === 'isEnabledAffiliate' && 'เปิด'}
                    {selectedConfig.name === 'isEnableSlip' && 'เปิด'}
                    {selectedConfig.name === 'isEnableNokshop' && 'เปิด'}
                    {selectedConfig.name === 'allowCharity' && 'เปิด'}
                  </option>
                  <option key={'fasle'} value={false}>
                    {selectedConfig.name === 'isRoundClosed' && 'เปิดซื้อขาย'}
                    {selectedConfig.name === 'showResult' && 'ไม่แสดง'}
                    {selectedConfig.name === 'showBox' && 'ปิด'}
                    {selectedConfig.name === 'isEnableQRcode' && 'ปิด'}
                    {selectedConfig.name === 'isEnabledPoint' && 'ปิด'}
                    {selectedConfig.name === 'isEnabledPreOrder' && 'ปิด'}
                    {selectedConfig.name === 'isEnabledAffiliate' && 'ปิด'}
                    {selectedConfig.name === 'isEnableSlip' && 'ปิด'}
                    {selectedConfig.name === 'isEnableNokshop' && 'ปิด'}
                    {selectedConfig.name === 'allowCharity' && 'ปิด'}
                  </option>
                </select>
              )}
              {(inputType === 'photo' || inputType === 'round-close-image') && (
                <div className="w-full px-3" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                  <Button
                    style={{ width: '100%', marginBottom: '12px' }}
                    variant="info"
                    onClick={() => inputRef.current.click()}
                  >
                    คลิกเพื่อเลือกรูปภาพ
                  </Button>
                  {pathImg && (
                    <div style={{ position: 'relative' }}>
                      <img src={pathImg} alt="รูปภาพที่เลือก" height="250px" />
                      <div
                        style={{
                          position: 'absolute',
                          top: 2,
                          right: 2,
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          aspectRatio: '1/1',
                          width: '30px',
                          justifyContent: 'center',
                          borderRadius: '50%',
                          background: 'rgba(0,0,0,0.2)',
                          color: 'black',
                        }}
                        onClick={() => {
                          setPathImg('')
                          setFileImg('')
                        }}
                      >
                        X
                      </div>
                    </div>
                  )}
                  <input type="file" hidden ref={inputRef} onChange={(e) => uploadImg(e)} />
                </div>
              )}
            </strong>
            {/* </li> */}
            {inputType === 'select-live' && (
              <li>
                <div>
                  <select
                    className="form-control"
                    placeholder=""
                    value={value}
                    style={{ width: 250, marginBottom: 10 }}
                    onChange={(e) => setValue(e.target.value)}
                  >
                    <option value="prize">prize</option>
                    <option value="search">search</option>
                    <option value="scan">scan</option>
                  </select>
                </div>
              </li>
            )}
            {inputType === 'noFee' && <ManageNoFee setIsVisible={setIsVisible} onClose={onClose} />}
            {inputType === 'prizes-share-campaign' && <PrizesShareCampaignForm value={value} />}
          </ul>
        </Col>
      </Row>
      {inputType !== 'noFee' && showButton && (
        <Card.Footer className="p-3 d-sm-flex  align-items-center">
          {/* <Button className='mr-2 btn btn-danger light' key="back" onClick={() => setIsVisible(false)}>ยกเลิก</Button> */}
          <Button
            className="mr-2 btn btn-success light"
            style={{ width: '100%' }}
            key="submit"
            type="primary"
            onClick={() => legacyUpdateConfig()}
          >
            บันทึกข้อมูล
          </Button>
        </Card.Footer>
      )}
    </Card>
  )
}

const NextRoundConfig = ({ value = '', onSave = async (name, value) => {} }) => {
  const [config, setConfig] = useState({ isSchedule: true, date: null, hour: '00', min: '00' })

  useEffect(() => {
    if (!value || typeof value !== 'string' || !value.match(/([0-9]*)-([0-9]*)-([0-9]*) ([0-9]*):([0-9]*)/)) {
      return
    }

    const [dateStr, time] = value.split(' ')
    const [hour, min] = time.split(':')

    const date = parse(dateStr, 'dd-MM-yy', new Date())

    setConfig((prev) => {
      return { ...prev, date: date, hour: hour, min: min }
    })
  }, [value])

  return (
    <>
      <div className="row">
        <div className="form-group col-md-4">
          <Form.Group>
            <Form.Label>วัน</Form.Label>
            <Form.Control
              onChange={(e) => {
                if (e.target.value === '') {
                  setConfig((prev) => {
                    return { ...prev, date: null, min: '00', hour: '00' }
                  })
                  return
                }

                setConfig((prev) => {
                  return { ...prev, date: parse(e.target.value, 'yyyy-MM-dd', new Date()) }
                })
              }}
              value={config.date ? format(config.date, 'yyyy-MM-dd') : ''}
              min={format(new Date(), 'yyyy-MM-dd')}
              type="date"
              placeholder="Next round"
            />
          </Form.Group>
        </div>
        <div className="form-group col-md-2" style={{ display: config.date ? 'block' : 'none' }}>
          <Form.Group>
            <Form.Label>ชั่วโมง</Form.Label>
            <select
              className="form-control"
              value={config.hour}
              onChange={(e) => {
                setConfig((prev) => {
                  return { ...prev, hour: e.target.value }
                })
              }}
            >
              {Array(24)
                .fill(0)
                .map((_, i) => {
                  return (
                    <option key={`hour-option-${i}`} value={i < 10 ? `0${i}` : `${i}`}>
                      {i < 10 ? `0${i}` : `${i}`}
                    </option>
                  )
                })}
            </select>
          </Form.Group>
        </div>
        <div className="form-group col-md-2" style={{ display: config.date ? 'block' : 'none' }}>
          <Form.Group>
            <Form.Label>นาที</Form.Label>
            <select
              className="form-control"
              value={config.min}
              onChange={(e) => {
                setConfig((prev) => {
                  return { ...prev, min: e.target.value }
                })
              }}
            >
              {Array(60)
                .fill(0)
                .map((_, i) => {
                  return (
                    <option key={`min-option-${i}`} value={i < 10 ? `0${i}` : `${i}`}>
                      {i < 10 ? `0${i}` : `${i}`}
                    </option>
                  )
                })}
            </select>
          </Form.Group>
        </div>
        <div className="form-group col-md-2" style={{ display: config.date ? 'block' : 'none' }}>
          <Form.Group>
            <Form.Label>ตั้งเวลาเปิด</Form.Label>
            <Form.Check
              checked={config.isSchedule}
              onChange={(e) => {
                setConfig((prev) => {
                  return { ...prev, isSchedule: e.target.checked }
                })
              }}
            />
          </Form.Group>
        </div>
      </div>
      <Button
        onClick={async () => {
          const date = config.date
          if (date) {
            date.setHours(Number(config.hour), Number(config.min))
          }
          await onSave('nextopenround', {
            isSchedule: config.isSchedule,
            nextOpenRound: date ? date.toJSON() : undefined,
          })
        }}
      >
        บันทึก
      </Button>
    </>
  )
}
